import { render, staticRenderFns } from "./ui-menu-tree.vue?vue&type=template&id=3741ff0c&scoped=true"
import script from "./ui-menu-tree.vue?vue&type=script&lang=js"
export * from "./ui-menu-tree.vue?vue&type=script&lang=js"
import style0 from "./ui-menu-tree.vue?vue&type=style&index=0&id=3741ff0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3741ff0c",
  null
  
)

export default component.exports